//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepeatDetailsItem } from './RepeatDetailsItem';

export class CalendarConflictCheckSearchOptions extends ItemBase {
    StudentIDs: string[] = [];
    Duration: number = 0;
    EventLocationID: string | null = null;
    EventStartDate: string = "1970-01-01T00:00:00";
    EventIDsToIgnore: string[] = [];
    RepeatDetails: RepeatDetailsItem | null = null;
    TeacherID: string | null = null;

    constructor(initializer?: Partial<CalendarConflictCheckSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarConflictCheckSearchOptions";
}
